import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { PageShareResult } from "models/interfaces/page-share-result";

const defaultValues = RecordUtils.defaultValuesFactory<PageShareResult>({
    pageShareCreateFailedEmails: [],
    emailSendFailedEmails: [],
});

export class PageShareResultRecord
    extends Record(defaultValues)
    implements PageShareResult
{
    constructor(params?: PageShareResult) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }
}

export default PageShareResultRecord;
